import { updatePostUseCase } from "../../shared/useCases/post/updatePostUseCase";
import type { GetPostStore } from "../../shared/useCases/post/updatePostUseCase";

const getPostUseCase = async (store: GetPostStore) => {
    return updatePostUseCase(store, false);
}

export { getPostUseCase };